<p-card
  *ngIf="withCard"
  styleClass="very-compact-card p-3 {{ styleClass }}">
  <h3 class="m-0">Права на управление</h3>
  <p-messages
    *ngIf="isAdmin"
    styleClass="mt-3"
    severity="info">
    <ng-template pTemplate="">
      <div class="flex gap-2 align-items-center">
        <i
          class="pi pi-exclamation-circle"
          style="font-size: 1.3rem"></i>
        <p>Админ имеет полные права</p>
      </div>
    </ng-template>
  </p-messages>
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</p-card>

<ng-container *ngIf="!withCard">
  <p-messages
    *ngIf="isAdmin"
    styleClass="mt-3"
    severity="info">
    <ng-template pTemplate="">
      <div class="flex gap-2 align-items-center">
        <i
          class="pi pi-exclamation-circle"
          style="font-size: 1.3rem"></i>
        <p>Админ имеет полные права</p>
      </div>
    </ng-template>
  </p-messages>
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</ng-container>

<ng-template #content>
  <div class="flex flex-column gap-3 mt-3">
    @if (!loading) {
      @for (right of accessRights; track $index) {
        @if (right.visible) {
          @if (right.group) {
            <div>
              <h4 class="mt-3 mb-2">{{ right.label }}</h4>
              @for (childRight of right.children; track $index) {
                @if (childRight.visible) {
                  <div class="flex align-items-center justify-content-between gap-2 py-1 pl-4">
                    <div>
                      <label [for]="childRight.key">{{ childRight.label }}</label>
                      <p class="text-gray-500 text-sm">{{ childRight.hint }}</p>
                    </div>
                    <p-inputSwitch
                      [id]="childRight.key"
                      [(ngModel)]="isAdmin ? true : userAccessControl[childRight.key]"
                      [disabled]="isAdmin || !currentUserHasEditPermission"
                      (onChange)="onAccessChange(user)"></p-inputSwitch>
                  </div>
                }
              }
            </div>
          } @else {
            <div class="flex align-items-center justify-content-between gap-2 py-1">
              <div>
                <label [for]="right.key">{{ right.label }}</label>
                <p class="text-gray-500 text-sm">{{ right.hint }}</p>
              </div>
              <p-inputSwitch
                [id]="right.key"
                [(ngModel)]="isAdmin ? true : userAccessControl[right.key]"
                [disabled]="isAdmin || !currentUserHasEditPermission"
                (onChange)="onAccessChange(user)"></p-inputSwitch>
            </div>
          }
        }
      }
    } @else {
      <crm-spinner top="mt-4"></crm-spinner>
    }
  </div>
</ng-template>
